import { formattingNumber } from './../utils'
export const generate_one_option = () => ({
    tooltip: {
        trigger: 'axis',
        axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
        },
        formatter(params) {
            let relVal = params[0].name + "<br/>";
            relVal += params[0].seriesName + ' : ' + (formattingNumber(Math.abs(params[0].value))) + "<br/>";
            relVal += params[1].seriesName + ' : ' + (formattingNumber(Math.abs(params[1].value))) + "<br/>";
            return relVal;
        },
    },
    color: ['#7FBDF2', '#5AC4A0'],
    legend: {
        show: true,
        type: 'plain',
        top: 0,
        left: 140,
    },
    grid: {
        show: false, // 不显示网格
        borderWidth: 0, 
        top:'15%',
        left: '3%',
        right: '3%',
        bottom: 0,
        containLabel: true
    },
    xAxis: {
            // min: -500,
            // max: 500,
            type: 'value',
            show:false,
            minorTick: {
                show:false
            },
            minorSplitLine: {
                show:false
            },
            splitLine: {
                show: false
            }
            
        },
    yAxis: [
        {
            type: 'category',
            axisTick: {
                show: false
            },
            splitLine: {
                show: false
            },
            data: [],
            axisLabel: {
                show: true,
                fontSize:14,
                fontWeight: 'bold',
                align: 'right',
                width: '20%'
            },
            name: '',
            nameTextStyle: {
            color: '#969696',
            padding: [0, 0, -10, 0]  
        },
       }, 
    ],
    series: [
        {
            name: '上月同期',
            type: 'bar',
            stack: '总量',
            barWidth: 30,
            label: {
                show: true,
                position: 'left',
            },
            data: []
        },
        {
            name: '当期',
            type: 'bar',
            stack: '总量',
            barWidth: 30,
            label: {
                show: true,
                position: 'right'
            },
            data: []
        },
    ]
});


export const handle_one_data = (value, max, all_position, callback = formattingNumber) => {
    let position = null
    let color = '#000000'
    if (all_position === 'left') {
        if (Math.abs(value / max) > 0.55) {
            position = 'insideLeft'
            color = '#000000'
        } else {
            position = 'left' 
        }
    } else {
        if (Math.abs(value / max) > 0.55) {
            position = 'insideRight'
            color = '#000000'
        } else {
            position = 'right' 
        }
    }
    return {
        value,
        label: {
            show:true,
            color,
            // color: value>0? '#EB8282':'#54C4A0',
            
            formatter:() => `${callback(Math.abs(value))}`,
            position,
        },
        itemStyle: {
            opacity:0.6,
            borderType: 'solid',
            borderWidth: 2,
            //     color:['#EEB499','#C5CB81'],
            //  ['#7FBDF2','#5AC4A0']
            borderColor: value > 0 ? '#5AC4A0' : '#7FBDF2',
            // normal: (params) => {
            //     var colorList = ['#EB8282','#54C4A0'];
            //     return colorList[params.dataIndex]; 
            // }
        }
    }
} 